export default "https://cdn-static.gokick.com/assets/7e5886a8604a8a782ca6a0de4eecb197b7d69c39/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";